import { render, staticRenderFns } from "./SectionCreate.vue?vue&type=template&id=0276dcac&scoped=true&"
import script from "./SectionCreate.vue?vue&type=script&lang=js&"
export * from "./SectionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0276dcac",
  null
  
)

export default component.exports